<template lang="pug">
control-decorator(:label="label" :tip="tip" :hint="hint" :errors="errors" :uid="uid" :hint-after-label="true")
    .search-input-wrapper(v-if="options.length > 5")
        i.icon-magnifying-glass
        input(name="search-input" v-model="search" placeholder="Search")
    .buttons-choice-control(:class="{inline}")
        label.button(v-for="opt in filteredOptions" :key="opt.value" :class="{selected: value === opt.value, disabled}")
            input(
                type="radio"
                :checked="value === opt.value"
                :disabled="disabled"
                :name="name"
                :value="opt.value"
                @input="input")
            span.text {{ opt.label }}
</template>
<script>
// Components
import BaseControl from './BaseControl.vue';

export default {
    name: 'ButtonsChoiceControl',

    extends: BaseControl,

    data() {
        return {
            search: ''
        };
    },

    props: {
        options: {
            type: Array,
            required: true
        },
        inline: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        filteredOptions() {
            if (!this.search) {
                return this.options;
            }

            const query = this.search.toLowerCase();
            return this.options.filter(opt =>
                String(opt.label).toLowerCase().includes(query)
            );
        }
    },
};
</script>
